import React, { useState, useEffect, useRef } from 'react';

/**
 * Combobox editable: muestra opciones de una lista pero permite escribir libre.
 * options: array de strings
 * onNuevoValor: callback opcional que se llama cuando se confirma agregar un valor nuevo a la lista
 *               (por ejemplo, para guardarlo en el catálogo del servidor)
 */
export function Combobox({ value, onChange, options = [], placeholder = '', onNuevoValor, nombreEntidad = 'valor' }) {
  const [texto, setTexto] = useState(value || '');
  const [abierto, setAbierto] = useState(false);
  const [confirmandoNuevo, setConfirmandoNuevo] = useState(null);
  const seleccionEnCursoRef = useRef(false);
  const ref = useRef(null);

  useEffect(() => setTexto(value || ''), [value]);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtradas = options.filter(o =>
    o.toLowerCase().includes(texto.toLowerCase())
  ).slice(0, 20);

  // Comparación insensible a mayúsculas/espacios, para no marcar como "nuevo"
  // algo que en realidad ya está en la lista pero con distinta capitalización
  const existeEnLista = (val) => options.some(o => o.trim().toLowerCase() === val.trim().toLowerCase());

  const seleccionar = (opt) => {
    setTexto(opt);
    onChange(opt);
    setAbierto(false);
    setConfirmandoNuevo(null);
  };

  const handleInputChange = (e) => {
    setTexto(e.target.value);
    onChange(e.target.value);
    setAbierto(true);
    if (confirmandoNuevo) setConfirmandoNuevo(null);
  };

  const handleBlur = () => {
    // Si justo se está haciendo clic en una opción de la lista, no mostramos el aviso
    // (el mousedown de la opción se ejecuta antes que este blur, así que ya quedó marcado)
    if (seleccionEnCursoRef.current) {
      seleccionEnCursoRef.current = false;
      return;
    }
    setTimeout(() => {
      // Esperamos un instante para que el estado de texto/value ya esté asentado
      if (texto && texto.trim() && !existeEnLista(texto) && onNuevoValor) {
        setConfirmandoNuevo(texto);
      }
      setAbierto(false);
    }, 120);
  };

  const confirmarAgregar = () => {
    if (onNuevoValor) onNuevoValor(confirmandoNuevo);
    setConfirmandoNuevo(null);
  };

  return (
    <div className="combobox-wrap" ref={ref}>
      <input
        className="form-input"
        placeholder={placeholder}
        value={texto}
        onChange={handleInputChange}
        onFocus={() => setAbierto(true)}
        onBlur={handleBlur}
      />
      {abierto && filtradas.length > 0 && (
        <div className="combobox-list">
          {filtradas.map(opt => (
            <div key={opt} className="combobox-option"
              onMouseDown={() => { seleccionEnCursoRef.current = true; }}
              onClick={() => seleccionar(opt)}>
              {opt}
            </div>
          ))}
        </div>
      )}
      {confirmandoNuevo && (
        <div className="card" style={{ marginTop: '.4rem', padding: '.6rem .75rem', background: '#fff3e0' }}>
          <p style={{ fontSize: '.8125rem', color: '#92400e', marginBottom: '.5rem' }}>
            "{confirmandoNuevo}" no está en la lista de {nombreEntidad}. ¿Lo agregás para usarlo después?
          </p>
          <div style={{ display: 'flex', gap: '.4rem' }}>
            <button className="btn btn-secondary btn-sm" onClick={() => setConfirmandoNuevo(null)}>No, gracias</button>
            <button className="btn btn-primary btn-sm" onClick={confirmarAgregar}>Sí, agregar</button>
          </div>
        </div>
      )}
    </div>
  );
}
